import { Component, OnInit, Input } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthenticationService, HubBasicGroupAuthenticationService, OrganizationsService } from "@appcore/service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import * as shajs from "sha.js";
import { Organization } from "@data/organization";
import { environment } from "environments/environment";

@Component({
	selector: "app-login",
	templateUrl: "login.component.html",
	providers: [OrganizationsService]
})
export class LoginComponent implements OnInit {
	@Input()
	parent: any;
	adminRoleLevel: number;
	authError = false;
	//error: Error | null = null;
	//-----------
	// Individual org login stuff
	// TODO: Figure out how to turn this into a widget for fallback purposes
	bUseClassicLogin = false;
	isAuthenticated: boolean;
	isRequired: any;
	loading = false;
	loginForm: FormGroup;
	organizations = [];
	plsSupport = environment.plsSupport;
	returnUrl: string;
	submitted = false;
	//---------

	constructor(
		private authenticationService: AuthenticationService,
		private formBuilder: FormBuilder,
		private route: ActivatedRoute,
		private router: Router,
		private hubBasicAuthService: HubBasicGroupAuthenticationService,
		private organizationsService: OrganizationsService
	) {
		//Classic login stuff
		this.adminRoleLevel = hubBasicAuthService.adminRoleLevel;
		// redirect to home if already logged in
		/*
		if (this.authenticationService.currentUserValue) {
		  this.router.navigate(['/']);
		}
		*/
	}

	async login(): Promise<void> {
		try {
			await this.authenticationService.login(AuthenticationService.redirectUrl);
		} catch (err) {
			console.error(err);
			//this.error = err as Error;
			this.parent["showMessage"]("error", "An Error Has Occurred", err);
		}
	}

	showMessage(): void {
		//this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'PrimeNG rocks' });
	}

	hideMessage(): void {
		//this.msgs = [];
	}

	async ngOnInit(): Promise<void> {
		// this.isAuthenticated = await this.oktaAuthService.isAuthenticated();

		/*
		this.oktaAuthService.$isAuthenticated.subscribe((isAuthenticated: boolean) => {
		  this.isAuthenticated = isAuthenticated;
		});
		*/

		this.loginForm = this.formBuilder.group({
			password: ["", Validators.required],
			organization: ["", Validators.required]
		});

		if (this.bUseClassicLogin) {
			this.organizationsService.getOrganizations(true).subscribe(response => {
				this.organizations = (<Organization[]>response.payload).map(function (org: {
					orgName: string;
					orgID: any;
				}) {
					return {
						label: org.orgName,
						value: org.orgID
					};
				});

				this.organizations.unshift({
					label: "-- Choose Your Organization --",
					value: ""
				});
			});

			// get return url from route parameters or default to '/'
			if (this.route.snapshot.queryParams["returnUrl"] !== "/") {
				this.returnUrl = this.route.snapshot.queryParams["returnUrl"];
			} else {
				this.returnUrl = "/";
			}
		}
	}

	//Used for classic login
	get f() {
		return this.loginForm.controls;
	}

	onSubmit(): void {
		//Classic login
		if (this.bUseClassicLogin) {
			this.submitted = true;

			// stop here if form is invalid
			if (this.loginForm.invalid) {
				return;
			}

			this.loading = true;

			const fPWVal = this.f.password.value;
			const hashword = shajs("sha256").update(fPWVal).digest("hex");

			this.hubBasicAuthService
				.login({ orgID: this.f.organization.value, password: hashword })
				.pipe(first())
				.subscribe(
					user => {
						console.log("login service -> logged in");

						if (user["roleid"] !== this.adminRoleLevel) {
							console.log("Non-Admin Login");
							console.log(this.returnUrl);
							if (this.returnUrl === "/" || this.returnUrl === undefined) {
								this.router.navigate(["/client/org"]);
							} else {
								this.router.navigateByUrl(this.returnUrl);
							}
							this.loading = false;
						} else {
							this.router.navigateByUrl(this.returnUrl);
							this.loading = false;
						}
					},
					() => {
						this.authError = true;
						this.loading = false;
					}
				);
		}
	}
}
